export const sortText = (prop, isDesc) => (a, b) => {
  let valueA = a[prop];
  let valueB = b[prop];

  if (typeof valueA === 'string') {
    valueA = valueA.toLocaleLowerCase();
    valueB = valueB.toLocaleLowerCase();
  }

  if (valueA === valueB) {
    return 0;
  } else if (valueA > valueB) {
    return isDesc ? 1 : -1;
  } else {
    return isDesc ? -1 : 1;
  }
}